import * as actionTypes from '../actions/actionTypes';
import { FeatureFlagsActions } from '../../types/actiontypes/featureFlagsActions';
import { FeatureFlags, defaultFeatureFlags } from '../../utils/constants';

export type FeatureFlagsReducer = FeatureFlags;

export const initialState: FeatureFlagsReducer = { ...defaultFeatureFlags };

const reducer = (state: FeatureFlagsReducer = initialState, action: FeatureFlagsActions): FeatureFlagsReducer => {
  if (action.type === actionTypes.FEATURE_FLAGS_SET) {
    return { ...action.featureFlags };
  }
  return state;
};

export default reducer;
